export default "__VITE_ASSET__OogiBLKk__"